import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { DOM_ID } from '@UILayer/UILayer.types';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';

// IMAGES
import icon from './icon_wallet.svg';

import { Button } from '@UILayer/Inputs/Button';
import { getCasinoMenu, getPopClient } from '@Managers/Redux/AppState/AppState';
import { CASINO_MENU_ITEM_DEFAULT, TCasinoMenuItem } from '@Managers/Redux/AppState/AppState.types';
import { TPopClientFeatures } from '@ConfigLoader/Configs';
import { EDelegatedPages } from '@Managers/PopClient/UsePopClient.types';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';

const WalletButton: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: TCasinoMenuItem, newState: any) => ({ ...state, ...newState }), CASINO_MENU_ITEM_DEFAULT);

    const { t } = useTranslation();
    const casinoData = useAppSelector(getCasinoMenu);
    const popClientconfig = useAppSelector(getPopClient);
    const btnCN = cn(cn(styles.square_btn, styles.green_btn, styles.wallet_btn));

    useEffect(() => {
        if (casinoData && casinoData.cashier) {
            setState({ url: casinoData.cashier.url, title: casinoData.cashier.title });
        }
    }, [casinoData]);

    function buttonAction() {
        const popClient = popClientconfig.enabled;
        const available = popClientconfig.supportedFeatures[TPopClientFeatures.OPEN_PAGE]?.delegatePages?.includes(EDelegatedPages.DEPOSIT) ? true : false;

        if (popClient && available) {
            EventsCenter.emit(EGameEvents.OPEN_PAGE, {
                pageID: EDelegatedPages.DEPOSIT,
                url: state.url
            });
        } else {
            window.open(state.url, '_blank');
        }
    }

    return (
        <>
            <Button id={DOM_ID.BUTTON_WALLET} description={t('WCA_WALLET')} className={btnCN} onChange={buttonAction}>
                <img src={icon} alt={t('WCA_WALLET')} />
            </Button>
        </>
    );
};

export default WalletButton;
